import CatRootModulePropertiesPane from '../_CAT_ROOT_MODULE/CatRootModulePropertiesPane.jsx'

export default function PropertiesPaneCatRootVm(props) {
    return (
        <CatRootModulePropertiesPane
            {...props}
        />
    )
}
